import { Select } from "antd";
import { useEffect, useState } from "react";
import { AiFillCloseCircle } from "react-icons/ai";
import PropTypes from "prop-types";

export const DeviceFormulaOperation = ({
  closeable = false,
  onClose = () => {},
  onChange = () => {},
  operation = { option: "", value: "" },
  parameters = [],
  formulas = [],
  disabled = false,
  width = "150px",
}) => {
  const [option, setOption] = useState("");
  const [value, setValue] = useState("");

  useEffect(() => {
    setOption(operation.option);
    setValue(operation.value);
  }, [operation]);

  return (
    <div className="d-flex flex-column gap-2 " style={{ width, float: "left", position: "relative" }}>
      {closeable && (
        <AiFillCloseCircle style={{ position: "absolute", right: -5, top: -10, cursor: "pointer" }} onClick={onClose} />
      )}

      <input
        type="text"
        name="option"
        id="option"
        value={operation.value}
        className="form-control text-capitalize"
        disabled
        style={{ boxShadow: "none" }}
      />
      {/* {console.log({ value })} */}
      <div style={{ width: "100%" }}>
        {(() => {
          switch (option) {
            case "parameter":
              return (
                <Select
                  size="large"
                  // value={value || null}
                  onChange={(e, option) => {
                    setValue(e);
                    onChange({ value: e, parameter: option.id });
                  }}
                  style={{ boxShadow: "none", width: "100%" }}
                  disabled={disabled}
                  required
                  placeholder="Select Device Parameter"
                  showSearch
                  filterOption={(input, option) =>
                    // eslint-disable-next-line no-unsafe-optional-chaining
                    (option?.children ? option?.children?.toLowerCase() : "").includes(input?.toLowerCase())
                  }
                >
                  {parameters?.length > 0 &&
                    parameters.map((item) => (
                      <option value={item.value} key={item._id} id={item._id}>
                        {item.name}
                      </option>
                    ))}
                </Select>
              );
            case "operator":
              return (
                <select
                  name="option"
                  id="option"
                  value={value}
                  onChange={(e) => {
                    setValue(e.target.value);
                    onChange({ value: e.target.value });
                  }}
                  className={disabled ? "form-control" : "form-select"}
                  style={{ boxShadow: "none" }}
                  disabled={disabled}
                >
                  <option value={""} disabled>
                    Select Operator
                  </option>
                  <option value="+">+</option>
                  <option value="-">-</option>
                  <option value="x">x</option>
                  <option value="/">/</option>
                  <option value="(">(</option>
                  <option value=")">)</option>
                  <option value="=">=</option>
                </select>
              );
            case "formula":
              return (
                <select
                  name="option"
                  id="option"
                  value={value}
                  onChange={(e) => {
                    setValue(e.target.value);
                    onChange({ value: e.target.value, formula: e.target.selectedOptions[0].id });
                  }}
                  className="form-select"
                  style={{ boxShadow: "none" }}
                  disabled={disabled}
                >
                  <option>Select Formula</option>
                  {formulas?.length > 0 &&
                    formulas.map((item, index) => (
                      <option value={item.name} key={index} id={item._id}>
                        {item.name}
                      </option>
                    ))}
                </select>
              );

            case "time":
            case "area":
              return (
                <input
                  type="text"
                  name="option"
                  id="option"
                  value={option}
                  className="form-control text-capitalize"
                  disabled
                  style={{ boxShadow: "none" }}
                />
              );
            default:
              return (
                <input
                  type="text"
                  name="value"
                  id="value"
                  value={value}
                  onChange={(e) => {
                    setValue(e.target.value);
                    onChange({ value: e.target.value });
                  }}
                  className="form-control"
                  placeholder="Enter a value"
                  style={{ boxShadow: "none" }}
                  disabled={disabled}
                />
              );
          }
        })()}
      </div>
    </div>
  );
};

DeviceFormulaOperation.propTypes = {
  closeable: PropTypes.bool,
  onClose: PropTypes.func,
  onChange: PropTypes.func,
  operation: PropTypes.object,
  parameters: PropTypes.array,
  formulas: PropTypes.array,
  disabled: PropTypes.bool,
  width: PropTypes.string,
};
